module.exports = __webpack_public_path__ + "img/animals_duck.620223da.png";